import React from 'react';
import PropTypes from 'prop-types';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Snackbar from '@mui/material/Snackbar';
import Typography from '@mui/material/Typography';
import WifiIcon from '@mui/icons-material/Wifi';
import {
  OFFLINE_STATUS_TOOLBAR_LABELS,
  ONLINE_STATUS_SNACKBAR_COLORS,
  STATUS_SNACKBAR_AUTO_HIDE_MS,
} from '../constants/offlineStatusToolbarLabels';

export default function OnlineStatusSnackbar({ open, onClose }) {
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={STATUS_SNACKBAR_AUTO_HIDE_MS}
      id="sc-online_status_snackbar"
      open={open}
      onClose={onClose}
    >
      <Alert
        icon={false}
        severity="success"
        variant="outlined"
        sx={{
          alignItems: 'center',
          backgroundColor: ONLINE_STATUS_SNACKBAR_COLORS.background,
          borderColor: ONLINE_STATUS_SNACKBAR_COLORS.main,
          color: ONLINE_STATUS_SNACKBAR_COLORS.main,
          maxWidth: 480,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
          }}
        >
          <WifiIcon
            aria-hidden
            sx={{ flexShrink: 0 }}
          />
          <Box>
            <Typography
              component="p"
              sx={{
                fontWeight: 600,
                lineHeight: 1.4,
                m: 0,
              }}
            >
              {OFFLINE_STATUS_TOOLBAR_LABELS.ONLINE_SNACKBAR_TITLE}
            </Typography>
            <Typography
              component="p"
              sx={{
                fontWeight: 400,
                lineHeight: 1.4,
                m: 0,
                mt: 0.5,
              }}
              variant="body2"
            >
              {OFFLINE_STATUS_TOOLBAR_LABELS.ONLINE_SNACKBAR_SUBTITLE}
            </Typography>
          </Box>
        </Box>
      </Alert>
    </Snackbar>
  );
}

OnlineStatusSnackbar.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
